export default "__VITE_ASSET__CPsisUed__"